import HighlightedMessageWidget from '../../widgets/HighlightedMessageWidget';
import { loadWidgetData, applyWidgetData, RELOAD_INTERVAL } from './common';

const DATA = [ 'eventTypes', 'giftTypes', 'textReplacements', 'serviceIcons', 'userData' ];

export default async function mountHighlightedMessage(host) {
	const widget = new HighlightedMessageWidget({ container: host.container });
	await widget.init(await loadWidgetData(host, DATA));

	host.onSettingsChange(s => widget.applySettings(s));
	const reload = async () => applyWidgetData(widget, await loadWidgetData(host, DATA));

	host.subscribe({
		reconnect: reload,
		messageHighlighted: msg => widget._handleHighlight(msg),
		messageUnhighlighted: () => widget._handleHighlight(null),
		userTextReplacementsChange: d => widget.applyTextReplacements(d),
		userEventTypeChange: d => widget.applyEventType(d.eventType, d.data),
		userGiftTypeChange: d => widget.applyGiftType(d.serviceId, d.giftType, d.data),
	});

	host.every(reload, RELOAD_INTERVAL);
	host.onDestroy(() => widget.destroy());
}
